import React, {useContext} from "react"
import { Outlet, Navigate, useLocation } from "react-router-dom"
import { UserContext } from "../contexts/UserContext";
export default function AuthRequired() {
    // const isLoggedIn = localStorage.getItem("loggedin")
    const location = useLocation()
    const { userInfo } = useContext(UserContext);

    if (userInfo?.role !== "admin") {
        return (
            <Navigate 
                to="/" 
             
                replace
            />)
    }
    return <Outlet />
}